module.exports = __webpack_public_path__ + "catalog/items/firesafety/youAreHere/you-are-here.svg";